
import { Injectable } from "@angular/core";
import { ApiService } from "../../http/api.service";
import { PageRequestModel, PageResponseModel } from "../../models/page.model";
import { ManualByIDModel, ManualCuUpdateModel, ManualItemCriteriaModel, ManualItemModel, SearchELiManualModel, SearchManualModel } from "../../models/manual/manual.model";
import { FileModel } from "../../models/shared/file.model";
//import { promises } from "dns";
//import { manualData } from "./manual.mock";



@Injectable({
    providedIn:'root'
})
export class ManualService{
    constructor(
        private apiService:ApiService,
    ){}
    
    async search(PageRequest: PageRequestModel<ManualItemCriteriaModel>): Promise<PageResponseModel<ManualItemModel>>{
       console.log(PageRequest);

        const dataResponse: PageResponseModel<ManualItemModel> = new PageResponseModel<ManualItemModel>();
       // const result = manualData
///api/v1/manual-eli/search
        const result = await this.apiService.post<PageResponseModel<ManualItemModel>>('/manual-eli/search',PageRequest);
        dataResponse.pageCount = result!.pageCount;
        dataResponse.pageNumber = result!.pageNumber;
        dataResponse.pageSize = result!.pageSize;
        dataResponse.totalItemCount = result!.totalItemCount;
        dataResponse.items = result!.items;
        return dataResponse;
    }
///api/v1/manual-elit/search
    async searchV2(PageRequest: PageRequestModel<ManualItemCriteriaModel>): Promise<PageResponseModel<ManualItemModel>>{
        console.log(PageRequest);
 
         const dataResponse: PageResponseModel<ManualItemModel> = new PageResponseModel<ManualItemModel>();
        // const result = manualData
 
         const result = await this.apiService.post<PageResponseModel<ManualItemModel>>('/manual-elit/search',PageRequest);
         dataResponse.pageCount = result!.pageCount;
         dataResponse.pageNumber = result!.pageNumber;
         dataResponse.pageSize = result!.pageSize;
         dataResponse.totalItemCount = result!.totalItemCount;
         dataResponse.items = result!.items;
         return dataResponse;
     }





    async createManual(item: any): Promise<boolean>
    {
        const result = await this.apiService.post<boolean>('/manual-elit/CreateManualEli',item);
        return result!;
    }

    ///api/v1/manual-elit/CreateManualEli-V2
    async createManualv2(file: File, item: any): Promise<boolean>
    {
        const formData: FormData = new FormData();
        formData.append('muCode', item.muCode);
        formData.append('muDetail', item.muDetail);
        formData.append('status', item.status);
        formData.append('file', file);
        const result = await this.apiService.post<boolean>('/manual-elit/CreateManualEli-V2',formData);
        return result!;
    }

    async updateManual(item: any):  Promise<boolean>
    {
        const result = await this.apiService.patch<boolean>('/manual-elit/UpdateManualEli',item);
        return result!;
    }

    ///api/v1/manual-elit/UpdateManualEliV2
    async updateManualv2(file: File, item: any): Promise<boolean>
    {
        const formData: FormData = new FormData();
        formData.append('muId', item.muId);
        formData.append('muCode', item.muCode);
        formData.append('muDetail', item.muDetail);
        formData.append('status', item.status);
        formData.append('file', file);
        const result = await this.apiService.patch<boolean>('/manual-elit/UpdateManualEliV2',formData);
        return result!;
    }

///api/v1/admin/Admin-Manual-Elit/ChkAuthManualEli
    async authManual():  Promise<boolean>
    {
        const result = await this.apiService.post<boolean>('/manual-elit/ChkAuthManualEli');
        return result!;
    }

   /* async UploadFile(item: any): Promise<boolean>
    {
       
        const result = await this.apiService.post<boolean>('/manual-elit/UploadFileManualEli',item);
        return result!;
    }*/

    async uploadFilePDF(manuLID: number): Promise<FileModel> {
        const result = await this.apiService.get<FileModel>(`/manual-elit/UploadFileManualEli/${manuLID}/generate-file/get`);
        return result!;
    }

    async getByIdManual(item:ManualByIDModel):Promise<ManualCuUpdateModel>{
        const result = await this.apiService.post<ManualCuUpdateModel>(`/manual-elit/GetManualEliById`,item);
        return result!;

       /* const request = {
            muId:item.muId
          }
          const result = await this.apiService.post<ManualCuUpdateModel>(`/manual-elit/GetManualEliById`,request);
          return result!;*/
    }


    async deleteIdManual(manuLID: number): Promise<boolean> {
        let result:any
        result = await this.apiService.delete<boolean>(`/manual-elit/DeleteManualEli/${manuLID}`);
        return result!;
    }

}



